<div class="section" style="flex: 1; display: flex; flex-direction: column; background-color: #ffffff !important;" data-cy="claim-status-dx-dialog">
  <div class="section-header" style="flex-basis: fit-content;" data-cy="claim-status-dx-dialog-header">
    <div class="section-header-title" data-cy="claim-status-dx-dialog-title">
      Patient Claim Status
    </div>
  </div>

  <div *ngIf="!isLoading && dxClaimStatusResponse && dxClaimStatusResponse.status && !dxClaimStatusResponse.response" style="overflow-y: auto; height:650px; padding: 10px 10px 10px 10px;" data-cy="claim-status-dx-dialog-error">
    <!-- error exists-->
    <b>DentalXChange Error</b><br>
    {{ dxClaimStatusResponse.status.code + ' ' + dxClaimStatusResponse.status.description }}
  </div>

  <div *ngIf="!isLoading && dxClaimStatusResponse && dxClaimStatusResponse.response"  style="overflow-y: auto; height:650px; padding: 10px 10px 10px 10px;" data-cy="claim-status-dx-dialog-content">
    <div *ngIf="dxClaimStatusResponse.response.claimStatus" data-cy="claim-status-dx-dialog-claim-status">
      <div class="eligibility-section-header" data-cy="claim-status-dx-dialog-claim-status-header">Claim Status</div>

      <div *ngIf="dxClaimStatusResponse.response.claimStatus.submittedAmount" style="display: flex; flex-direction: row" data-cy="claim-status-dx-dialog-submitted-amount-container">
        <div style="flex:1" class="eligibility-section-item-name" data-cy="claim-status-dx-dialog-submitted-amount-label">Submitted Amount</div>
        <div style="flex:2" data-cy="claim-status-dx-dialog-submitted-amount-value">{{ dxClaimStatusResponse.response.claimStatus.submittedAmount | currency }}</div>
      </div>
      <div *ngIf="dxClaimStatusResponse.response.claimStatus.paidAmount" style="display: flex; flex-direction: row" data-cy="claim-status-dx-dialog-paid-amount-container">
        <div style="flex:1" class="eligibility-section-item-name" data-cy="claim-status-dx-dialog-paid-amount-label">Paid Amount</div>
        <div style="flex:2; white-space: pre-line" data-cy="claim-status-dx-dialog-paid-amount-value">{{ dxClaimStatusResponse.response.claimStatus.paidAmount | currency }}</div>
      </div>
      <div *ngIf="dxClaimStatusResponse.response.claimStatus.statusDate" style="display: flex; flex-direction: row" data-cy="claim-status-dx-dialog-status-date-container">
        <div style="flex:1" class="eligibility-section-item-name" data-cy="claim-status-dx-dialog-status-date-label">Status Date</div>
        <div style="flex:2" data-cy="claim-status-dx-dialog-status-date-value">{{ dxClaimStatusResponse.response.claimStatus.statusDate | date }}</div>
      </div>
      <div *ngIf="dxClaimStatusResponse.response.claimStatus.adjudicationDate" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Adjudication Date</div>
        <div style="flex:2">{{ dxClaimStatusResponse.response.claimStatus.adjudicationDate | date }}</div>
      </div>
      <div *ngIf="dxClaimStatusResponse.response.claimStatus.paymentMethod" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Payment Method</div>
        <div style="flex:2">{{ dxClaimStatusResponse.response.claimStatus.paymentMethod }}</div>
      </div>
      <div *ngIf="dxClaimStatusResponse.response.claimStatus.paymentDate" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Payment Date</div>
        <div style="flex:2">{{ dxClaimStatusResponse.response.claimStatus.paymentDate | date }}</div>
      </div>
      <div *ngIf="dxClaimStatusResponse.response.claimStatus.checkNumber" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Check Number</div>
        <div style="flex:2">{{ dxClaimStatusResponse.response.claimStatus.checkNumber }}</div>
      </div>
      <div *ngIf="dxClaimStatusResponse.response.claimStatus.message" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Message</div>
        <div style="flex:2">{{ dxClaimStatusResponse.response.claimStatus.message }}</div>
      </div>
      <div *ngIf="dxClaimStatusResponse.response.claimStatus.categoryCodes && dxClaimStatusResponse.response.claimStatus.categoryCodes.length > 0" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Category Codes</div>
        <div style="flex:2">
          <div class="eligibility-section-header" style="display: flex">
            <div style="flex: 1;">Code</div>
            <div style="flex: 1;">Status Code</div>
            <div style="flex: 1;">Entity Code</div>
          </div>
          <div *ngFor="let code of dxClaimStatusResponse.response.claimStatus.categoryCodes">
            <div style="display: flex">
              <div style="flex: 1;">{{ code.code }}</div>
              <div style="flex: 1;">{{ code.statusCode }}</div>
              <div style="flex: 1;">{{ code.entityCode }}</div>
            </div>
            <div *ngIf="code.code" style="display: flex">
              <div style="flex-basis: 50px; font-weight: bold">{{ code.code }}:</div>
              <div style="flex:1">{{ returnCodeText(code.code, 1) }}</div>
            </div>
            <div *ngIf="code.statusCode" style="display: flex">
              <div style="flex-basis: 50px; font-weight: bold">{{ code.statusCode }}:</div>
              <div style="flex:1">{{ returnCodeText(code.statusCode, 2) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="dxClaimStatusResponse.response.attachmentStatus" data-cy="claim-status-dx-dialog-attachment-status">
      <div class="eligibility-section-header" data-cy="claim-status-dx-dialog-attachment-status-header">Attachment Status</div>

      <div *ngIf="dxClaimStatusResponse.response.attachmentStatus.hasAttachment" style="display: flex; flex-direction: row" data-cy="claim-status-dx-dialog-has-attachment-container">
        <div style="flex:1" class="eligibility-section-item-name" data-cy="claim-status-dx-dialog-has-attachment-label">Submitted Amount</div>
        <div style="flex:2" data-cy="claim-status-dx-dialog-has-attachment-value">{{ dxClaimStatusResponse.response.attachmentStatus.hasAttachment }}</div>
      </div>

      <div *ngIf="dxClaimStatusResponse.response.attachmentStatus.dxcAttachmentId" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">DXC Attachment ID</div>
        <div style="flex:2">{{ dxClaimStatusResponse.response.attachmentStatus.dxcAttachmentId }}</div>
      </div>

      <div *ngIf="dxClaimStatusResponse.response.attachmentStatus.viewedDate" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Viewed Date</div>
        <div style="flex:2">{{ dxClaimStatusResponse.response.attachmentStatus.viewedDate | date }}</div>
      </div>

      <div *ngIf="dxClaimStatusResponse.response.attachmentStatus.status" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Status</div>
        <div style="flex:2">{{ returnCodeText((dxClaimStatusResponse.response.attachmentStatus.status ? dxClaimStatusResponse.response.attachmentStatus.status.toString() : ''), 2) }}</div>
      </div>

      <div *ngIf="dxClaimStatusResponse.response.attachmentStatus.description" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Description</div>
        <div style="flex:2">{{ dxClaimStatusResponse.response.attachmentStatus.description }}</div>
      </div>
    </div>

    <div *ngIf="dxClaimStatusResponse.response.dxcStatus && (dxClaimStatusResponse.response.dxcStatus.claimErrors.length > 0 || dxClaimStatusResponse.response.dxcStatus.claimItemErrors.length > 0)" data-cy="claim-status-dx-dialog-dxc-status">
      <div class="eligibility-section-header" data-cy="claim-status-dx-dialog-dxc-status-header">DXC Status</div>

      <div *ngIf="dxClaimStatusResponse.response.dxcStatus.claimErrors && dxClaimStatusResponse.response.dxcStatus.claimErrors.length > 0" style="display: flex; flex-direction: row">
        <div style="flex:1" class="eligibility-section-item-name">Claim Errors</div>
        <div style="flex:2">
          <div *ngFor="let err of dxClaimStatusResponse.response.dxcStatus.claimErrors" style="border-bottom: solid 1px #000000">

            <div *ngIf="err.claimPart" style="display: flex; flex-direction: row">
              <div style="flex:1" class="eligibility-section-item-name">Claim Part</div>
              <div style="flex:2">{{ err.claimPart }}</div>
            </div>

            <div *ngIf="err.code" style="display: flex; flex-direction: row">
              <div style="flex:1" class="eligibility-section-item-name">Code</div>
              <div style="flex:2">{{ err.code }}</div>
            </div>

            <div *ngIf="err.description" style="display: flex; flex-direction: row">
              <div style="flex:1" class="eligibility-section-item-name">Description</div>
              <div style="flex:2">{{ err.description }}</div>
            </div>

            <div *ngIf="err.category" style="display: flex; flex-direction: row">
              <div style="flex:1" class="eligibility-section-item-name">Category</div>
              <div style="flex:2">{{ err.category }}</div>
            </div>

            <div *ngIf="err.statusCode" style="display: flex; flex-direction: row">
              <div style="flex:1" class="eligibility-section-item-name">Status Code</div>
              <div style="flex:2">{{ err.statusCode }}</div>
            </div>

            <div *ngIf="err.entityId" style="display: flex; flex-direction: row">
              <div style="flex:1" class="eligibility-section-item-name">Entity ID</div>
              <div style="flex:2">{{ err.entityId }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="dxClaimStatusResponse.response.dxcStatus.claimItemErrors && dxClaimStatusResponse.response.dxcStatus.claimItemErrors.length > 0" style="display: flex; flex-direction: row">
          <div style="flex:1" class="eligibility-section-item-name">Claim Item Errors</div>
          <div style="flex:2">

            <div class="eligibility-section-header" style="display: flex">
              <div style="flex: 1;">Claim Item</div>
              <div style="flex: 1;">Code</div>
            </div>
            <div *ngFor="let err of dxClaimStatusResponse.response.dxcStatus.claimItemErrors">
              <div style="display: flex">
                <div style="flex: 1;">{{ err.claimItem }}</div>
                <div style="flex: 1;">{{ err.code }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="dxClaimStatusResponse.response.claimItems && dxClaimStatusResponse.response.claimItems.length > 0" data-cy="claim-status-dx-dialog-claim-items">
      <div class="eligibility-section-header" data-cy="claim-status-dx-dialog-claim-items-header">Claim Items</div>

      <div *ngFor="let cItem of dxClaimStatusResponse.response.claimItems" style="border-bottom: solid 1px #000000">

        <div *ngIf="cItem.controlNumber" style="display: flex; flex-direction: row">
          <div style="flex:1" class="eligibility-section-item-name">Control Number</div>
          <div style="flex:2">{{ cItem.controlNumber }}</div>
        </div>

        <div *ngIf="cItem.quantity" style="display: flex; flex-direction: row">
          <div style="flex:1" class="eligibility-section-item-name">Quantity</div>
          <div style="flex:2">{{ cItem.quantity }}</div>
        </div>

        <div *ngIf="cItem.startDate" style="display: flex; flex-direction: row">
          <div style="flex:1" class="eligibility-section-item-name">Start Date</div>
          <div style="flex:2">{{ cItem.startDate | date }}</div>
        </div>

        <div *ngIf="cItem.endDate" style="display: flex; flex-direction: row">
          <div style="flex:1" class="eligibility-section-item-name">End Date</div>
          <div style="flex:2">{{ cItem.endDate }}</div>
        </div>

        <div *ngIf="cItem.itemStatus && cItem.itemStatus.length > 0" style="display: flex; flex-direction: row">
          <div style="flex:1" class="eligibility-section-item-name">Item Status</div>
          <div style="flex:2">
            <div *ngFor="let itemStatus of cItem.itemStatus" style="border-bottom: solid 1px #000000">

              <div *ngIf="itemStatus.submittedAmount" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Submitted Amount</div>
                <div style="flex:2">{{ itemStatus.submittedAmount | currency }}</div>
              </div>
              <div *ngIf="itemStatus.paidAmount" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Paid Amount</div>
                <div style="flex:2; white-space: pre-line">{{ itemStatus.paidAmount | currency }}</div>
              </div>
              <div *ngIf="itemStatus.statusDate" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Status Date</div>
                <div style="flex:2">{{ itemStatus.statusDate | date }}</div>
              </div>
              <div *ngIf="itemStatus.adjudicationDate" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Adjudication Date</div>
                <div style="flex:2">{{ itemStatus.adjudicationDate | date }}</div>
              </div>
              <div *ngIf="itemStatus.paymentMethod" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Payment Method</div>
                <div style="flex:2">{{ itemStatus.paymentMethod }}</div>
              </div>
              <div *ngIf="itemStatus.paymentDate" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Payment Date</div>
                <div style="flex:2">{{ itemStatus.paymentDate | date }}</div>
              </div>
              <div *ngIf="itemStatus.checkNumber" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Check Number</div>
                <div style="flex:2">{{ itemStatus.checkNumber }}</div>
              </div>
              <div *ngIf="itemStatus.message" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Message</div>
                <div style="flex:2">{{ itemStatus.message }}</div>
              </div>
              <div *ngIf="itemStatus.categoryCodes && itemStatus.categoryCodes.length > 0" style="display: flex; flex-direction: row">
                <div style="flex:1" class="eligibility-section-item-name">Category Codes</div>
                <div style="flex:2">
                  <div class="eligibility-section-header" style="display: flex">
                    <div style="flex: 1;">Code</div>
                    <div style="flex: 1;">Status Code</div>
                    <div style="flex: 1;">Entity Code</div>
                  </div>
                  <div *ngFor="let code of itemStatus.categoryCodes">
                    <div style="display: flex">
                      <div style="flex: 1;">{{ code.code }}</div>
                      <div style="flex: 1;">{{ code.statusCode }}</div>
                      <div style="flex: 1;">{{ code.entityCode }}</div>
                    </div>
                    <div *ngIf="code.code" style="display: flex">
                      <div style="flex-basis: 50px; font-weight: bold">{{ code.code }}:</div>
                      <div style="flex:1">{{ returnCodeText(code.code, 1) }}</div>
                    </div>
                    <div *ngIf="code.statusCode" style="display: flex">
                      <div style="flex-basis: 50px; font-weight: bold">{{ code.statusCode }}:</div>
                      <div style="flex:1">{{ returnCodeText(code.statusCode, 2) }}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="isLoading" class="loading-spinner" data-cy="claim-status-dx-dialog-spinner">
    <mat-spinner [diameter]="100" data-cy="claim-status-dx-dialog-spinner-element"></mat-spinner>
  </div>

  <mat-dialog-actions  *ngIf="!isLoading" align="end" style="padding: 10px 10px 10px 10px" data-cy="claim-status-dx-dialog-actions">
    <button (click)="closeWindow()" class="tdo-button tdo-close" color="primary" tabindex="-1" data-cy="claim-status-dx-dialog-close-btn">Close Window</button>
  </mat-dialog-actions>

</div>
